import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './constants';
import type { SupportedLanguage } from './types';

const isSupported = (lang?: string | null): lang is SupportedLanguage =>
	!!lang && SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);

export const resolveLanguage = (
	providedLang?: string | null,
	browserLang?: string
): SupportedLanguage => {
	if (isSupported(providedLang)) {
		return providedLang;
	}

	const shortBrowser = browserLang?.split('-')[0];
	if (isSupported(shortBrowser)) {
		return shortBrowser;
	}

	return DEFAULT_LANGUAGE;
};
